import { Box } from '@mantine/core';
import { ContentPaneOverlayProvider, ContentPaneOverlaySlot } from './ContentPaneOverlay';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  bgWidth?: string;
  paneWidth?: string;
  shouldTransition?: boolean;
};

export function AppContentPane({ children, style, bgWidth, paneWidth, shouldTransition }: Props) {
  return (
    <ContentPaneOverlayProvider>
      <Box
        h="100%"
        w={bgWidth || undefined}
        pos="relative"
        style={{
          backgroundColor: 'rgba(255, 119, 28, 0.4)',
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          flex: bgWidth ? undefined : 1,
          transition: shouldTransition ? 'width 0.2s ease-out' : 'none',
          ...style,
        }}
      >
        <ContentPaneOverlaySlot />
        <Box
          bg="white"
          px="xxl"
          py="lg"
          h="100%"
          w={paneWidth || '100%'}
          style={{
            borderRadius:
              'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
            overflow: 'auto',
            transition: shouldTransition ? 'width 0.2s ease-out' : 'none',
          }}
        >
          {children}
        </Box>
      </Box>
    </ContentPaneOverlayProvider>
  );
}
